import apiClient from './api.service';

export interface WidgetStorePolicy {
  searchIds: number[];
  forced: boolean;
}

export interface StorePreferencePolicies {
  android_widget: WidgetStorePolicy;
}

export interface ApplyPreferenceResult {
  changed: boolean;
  forced: boolean;
}

const preferencePolicyService = {
  async get(storeId: number): Promise<StorePreferencePolicies> {
    const response = await apiClient.get(`/stores/${storeId}/preference-policies`);
    return response.data.data;
  },

  async saveWidget(storeId: number, payload: WidgetStorePolicy): Promise<WidgetStorePolicy> {
    const response = await apiClient.put(
      `/stores/${storeId}/preference-policies/android_widget`,
      payload
    );
    return response.data.data.android_widget;
  },

  async apply(storeId: number): Promise<ApplyPreferenceResult> {
    const response = await apiClient.post('/me/preference-policies/apply', { storeId });
    return response.data.data;
  }
};

export default preferencePolicyService;
